import { wrapClick } from "utils";

type StepFooterProps = {
    onNext: () => void;
    onCancel: () => void;
    onPrevious?: () => void;
    nextLabel?: string;
    showPrevious?: boolean;
    nextDisabled?: boolean;
    busy?: boolean;
    busyLabel?: string;
};

const StepFooter = ({
    onNext,
    onCancel,
    onPrevious,
    nextLabel = "Next",
    showPrevious = false,
    nextDisabled = false,
    busy = false,
    busyLabel,
}: StepFooterProps) => {
    const disabled = busy || nextDisabled;

    return (
        <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:py-4 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200">
            <button
                type="button"
                onClick={wrapClick(onNext)}
                disabled={disabled}
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed">
                {busy ? busyLabel || nextLabel : nextLabel}
            </button>
            {showPrevious && onPrevious && (
                <button
                    type="button"
                    onClick={wrapClick(onPrevious)}
                    disabled={busy}
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed">
                    Previous
                </button>
            )}
            <button
                type="button"
                disabled={busy}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={wrapClick(onCancel)}>
                Cancel
            </button>
        </div>
    );
};

export default StepFooter;
